/**
 * Directive to maintain focus on an element even if it loses focus.
 */
export const vMaintainFocus = {
  mounted(el: HTMLElement) {
    el.focus();
    el.onblur = () => {
      el.focus();
    };
  },
  beforeUnmount(el: HTMLElement) {
    el.onblur = null;
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }
};
